<template>
  <div id="order-broker-transfer-form" class="mt-3">
    <v-row>
      <v-col cols="12" md="12" class="my-0 py-0">
        <div class="order-broker-transfer-form-description mt-6">
          <p>
            {{ $t('views.orders.orderModal.brokerTransfer.description') }}
            <br />
            {{ $t('views.orders.orderModal.brokerTransfer.description2') }}
          </p>
        </div>
        <div class="order-broker-transfer-form-flex">
          <div class="order-broker-transfer-form-broker-search">
            <BrokerSearch v-model="myOrder.broker" :disabled="loading" />
          </div>
          <div class="mx-5">
            <v-icon size="30">mdi-arrow-right-thin-circle-outline</v-icon>
          </div>
          <div class="order-broker-transfer-form-broker-search">
            <BrokerSearch v-model="myOrder.newBroker" :disabled="loading" />
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BrokerSearch from '@/views/components/common/BrokerSearch'

export default {
  components: { BrokerSearch },
  props: {
    myOrder: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
#order-broker-transfer-form {
  .order-broker-transfer-form-description {
    font-size: 14px;
    text-align: justify;
  }
  .order-broker-transfer-form-flex {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }
  .order-broker-transfer-form-broker-search {
    width: 100%;
  }
}
</style>
